import { useMutation, useQuery } from '@tanstack/react-query'
import { ProductPdfExportsFilterParams, CreateProductPdfExportParams } from '@/types/product-pdf-export'
import { useProductPdfExportsStore } from '@/store'
import { useBulkDeleteSuccessHandler } from './use-bulk-delete'

export const useProductPdfExports = (params: ProductPdfExportsFilterParams) => {
  const fetchProductPdfExports = useProductPdfExportsStore(state => state.fetchProductPdfExports)

  return useQuery({
    queryKey: ['productPdfExports', params],
    queryFn: () => fetchProductPdfExports(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useProductPdfExport = (id: string) => {
  const getProductPdfExport = useProductPdfExportsStore(state => state.getProductPdfExport)

  return useQuery({
    queryKey: ['productPdfExport', id],
    queryFn: () => getProductPdfExport(id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!id
  })
}

export const useCreateProductPdfExport = () => {
  const createProductPdfExport = useProductPdfExportsStore(state => state.createProductPdfExport)

  return useMutation({
    mutationFn: (params: CreateProductPdfExportParams) => createProductPdfExport(params),
    onSuccess: () => {}
  })
}

export const useDeleteProductPdfExport = () => {
  const deleteProductPdfExport = useProductPdfExportsStore(state => state.deleteProductPdfExport)

  return useMutation({
    mutationFn: (id: string) => deleteProductPdfExport(id),
    onSuccess: () => {}
  })
}

export const useBulkDeleteProductPdfExports = () => {
  const bulkDeleteProductPdfExports = useProductPdfExportsStore(state => state.bulkDeleteProductPdfExports)
  const deselectAllProductPdfExports = useProductPdfExportsStore(state => state.deselectAllProductPdfExports)
  const handleBulkDeleteSuccess = useBulkDeleteSuccessHandler()

  return useMutation({
    mutationFn: (ids: string[]) => bulkDeleteProductPdfExports(ids),
    onSuccess: response => {
      deselectAllProductPdfExports()
      handleBulkDeleteSuccess(response)
    }
  })
}
